import api from './MDL06-concern-api';

const VISIBLE = 'VISIBLE';
const SUCCESS = 'SUCCESS';
const FAIL = 'FAIL';
const DISPLAYED_ADDRESS = 'DISPLAYED_ADDRESS';
const DISPLAYED_CHOOSEN_SERVICES = 'DISPLAYED_CHOOSEN_SERVICES';

export default {
	namespaced: true,
	state: {
		visible: false,
		displayedAddress: '',
		displayedChoosenServices: '',
		success: false,
		fail: false
	},
	actions: {
		toggleModal({ state, commit }, params) {
			if (params) {
				commit(DISPLAYED_ADDRESS, params.displayedAddress);
				commit(DISPLAYED_CHOOSEN_SERVICES, params.displayedChoosenServices);
			}

			commit(VISIBLE, !state.visible);
		},

		sendConcern({ state, commit }, model) {
			const params = {
				1: {
					nev: model.name,
					email: model.email,
					telefon: model.phone,
					cim: state.displayedAddress,
					temak: state.displayedChoosenServices
				}
			};

			return new Promise((resolve, reject) => {
				api.sendConcern(params).then(response => {
					commit(SUCCESS, true);
					resolve();
				}).catch(error => {
					commit(FAIL, true);
					// console.error(error.message, 'In MDL06-concern-vuex/actions/sendConcern with params: ', params);
					window.EventBus.$emit('error');
					reject(error);
				});
			});
		},

		resetSuccess({ commit }) {
			commit(SUCCESS, false);
		},

		resetFail({ commit }) {
			commit(FAIL, false);
		}
	},
	mutations: {
		[VISIBLE](state, visible) {
			state.visible = visible;
		},
		[SUCCESS](state, success) {
			state.success = success;
		},
		[FAIL](state, fail) {
			state.fail = fail;
		},
		[DISPLAYED_ADDRESS](state, displayedAddress) {
			state.displayedAddress = displayedAddress;
		},
		[DISPLAYED_CHOOSEN_SERVICES](state, displayedChoosenServices) {
			state.displayedChoosenServices = displayedChoosenServices;
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/MDL06-concern/MDL06-concern-vuex.js